import React from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
export default function ReturnPage() {
    return (
        <div>
            <Header />
            <Breadcrumb />
            <div className="legal-container">
                <h1>Return & Replacement Policy</h1>
                <p>
                    At our store, we ensure that all product measurements are clearly provided in the size chart for every item. Customers are requested to carefully check the measurement chart before placing an order.
                </p>
                <section>
                    <h2>1. No Return for Size Issues</h2>
                    <p>We do not accept returns or exchanges due to size-related concerns, as all necessary sizing details are available prior to purchase.</p>
                    <h2>2. Return/Replacement for Damaged Products Only</h2>
                    <p>Returns or replacements are accepted only if the product received is damaged and change of color</p>
                    <h2>3. Mandatory Unboxing Video</h2>
                    <p>To process any damage-related claim, customers must provide a *360-degree unboxing video* clearly showing</p>
                    <ul>
                        <li>The package being opened</li>
                        <li>The product condition at the time of opening</li>
                    </ul>
                    <h2>Claims Without Video Will Not Be Accepted</h2>
                    <p>We appreciate your understanding and cooperation.</p>
                </section>
            </div>
            <Footer />
        </div>
    )
}
